<script lang="ts" generics="T extends SvelteComponent">
  import type { SvelteComponent } from 'svelte';
  import LoadingSpinner from '$mds/LoadingSpinner/LoadingSpinner.svelte';

  type ComponentType<T> = new (...args: any[]) => T;

  export let promise: () => Promise<ComponentType<T>>;
  export let condition = true;
  export let spinner: boolean | 'inline' = false;

  let componentCache: ComponentType<T>;
  $: if (condition) {
    promise().then(result => {
      componentCache = result;
    });
  }
</script>

{#if condition}
  {#if componentCache}
    <slot component={componentCache} />
  {:else if spinner}
    <!-- 
        a basic inline / full-page spinner, useful for drawers/dialogs which may take a second to load,
        use 'inline' for a spinner that's inline with the content
      -->
    {#if spinner !== 'inline'}
      <div class="bg-ondark-base/50 z-modal animate-fade-in-slow animate-ease-in-out fixed inset-0 delay-200"></div>
    {/if}
    <div
      class="z-modal animate-pop-in-slow flex items-center justify-center {spinner === 'inline'
        ? 'min-h-10 w-full'
        : 'fixed inset-0'}"
    >
      <LoadingSpinner theme="dark" size="lg" />
    </div>
  {/if}
{/if}
